import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface InfoCircleFilledIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const InfoCircleFilledIcon: React.FC<InfoCircleFilledIconProps> = ({
  size = 24,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg {...props} width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 4.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-0.75 4h1.5v5.5h-1.5z"
        fill={colors[color]}
      />
    </Svg>
  );
};

InfoCircleFilledIcon.displayName = 'InfoCircleFilledIcon';
